export default __webpack_public_path__ + "static/media/8.376f1834.jpeg";